<template>
  <div
    class="title-component"
    :class="{ 'pb-8': size === 'large', 'pb-6': size !== 'large' }"
  >
    <div class="title-sep-container">
      <div class="title-sep sep-double sep-solid"></div>
    </div>
    <h2 class="title-heading" :class="size">
      {{ title }}
    </h2>
    <div class="title-sep-container">
      <div class="title-sep sep-double sep-solid"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitleComponent",
  props: {
    title: String,
    size: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.title-component {
  text-align: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  .title-heading {
    &.large {
      font-size: 36px;
    }
    &.medium {
      font-size: 26px;
    }
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    margin: 0px;
    font-size: 18px;
    line-height: 1.5;
    font-family: "PT Sans";
    font-weight: bold;
    color: black;
    padding-right: 8px;
    margin: 0px 26px;
  }
  .title-sep-container {
    position: relative;
    height: 6px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    .title-sep {
      position: relative;
      display: block;
      border-style: solid;
      border: 0 solid #e7e6e6;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      border-color: #f09a3e;
      height: 6px;
      border-top-width: 1px;
      width: 100%;
    }
  }
}
</style>
